/** Human-readable label for a signing-envelope recipient status (raw enum -> plain language). */
const RECIPIENT_STATUS_LABELS: Record<string, string> = {
  PENDING: 'Not yet sent',
  SENT: 'Awaiting signature',
  OPENED: 'Viewed',
  SIGNED: 'Signed',
  DECLINED: 'Declined',
  ERROR: 'Delivery problem',
};

export function recipientStatusLabel(status: string): string {
  const known = RECIPIENT_STATUS_LABELS[status];
  if (known) return known;
  const spaced = status.toLowerCase().replace(/_/g, ' ').trim();
  return spaced ? spaced.charAt(0).toUpperCase() + spaced.slice(1) : 'Unknown';
}

/** Human-readable label for a signing-envelope status (raw enum -> plain language). */
const ENVELOPE_STATUS_LABELS: Record<string, string> = {
  DRAFT: 'Draft',
  PENDING: 'Pending',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
  EXPIRED: 'Expired',
  ERROR: 'Delivery problem',
};

export function envelopeStatusLabel(status: string): string {
  const known = ENVELOPE_STATUS_LABELS[status];
  if (known) return known;
  const spaced = status.toLowerCase().replace(/_/g, ' ').trim();
  return spaced ? spaced.charAt(0).toUpperCase() + spaced.slice(1) : 'Unknown';
}
